



















































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import { TableList } from '@/shims-global'
import { punchCardStatistics } from '@/api/education'
import Chart from '@/components/Chart/index.vue'
import dayjs from 'dayjs'
  interface SearchParams {
    fromTime: string | number;
    toTime: string | number
  }
  interface Info {
    studentName: string
    classroomName: string
    birthday: number
    punchCardNum: number
    time: number
    duration: number
    months: Array<any>
    weeks: Array<any>
  }

  @Component({
    name: '',
    components: { Chart }
  })
export default class extends Vue {
  get table() {
    return this.$refs.table as TableList
  }
  get id() {
    return this.$route.query.id
  }

    private searchParams: SearchParams = {
      fromTime: '',
      toTime: ''
    };
    private info: Info = {
      studentName: '',
      classroomName: '',
      birthday: 0,
      punchCardNum: 0,
      time: 0,
      duration: 0,
      months: [],
      weeks: []
    }
    private timeRange: Array<number> = []
    private weekChartOptions1:any = {
      color: ['#3A91FF'],
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        name: '打卡次数',
        type: 'value'
      },
      series: [
        {
          name: '打卡次数',
          type: 'line',
          data: []
        }
      ]
    }
    private weekChartOptions2:any = {
      color: ['#3A91FF'],
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        name: '游戏时长（分钟）',
        type: 'value'
      },
      series: [
        {
          name: '游戏时长',
          type: 'line',
          data: []
        }
      ]
    }
    private monthChartOptions1:any = {
      color: ['#3A91FF'],
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        name: '打卡次数',
        type: 'value'
      },
      series: [
        {
          name: '打卡次数',
          type: 'line',
          data: []
        }
      ]
    }
    private monthChartOptions2:any = {
      color: ['#3A91FF'],
      tooltip: {
        trigger: 'axis'
      },
      xAxis: {
        type: 'category',
        data: []
      },
      yAxis: {
        name: '游戏时长（分钟）',
        type: 'value'
      },
      series: [
        {
          name: '游戏时长',
          type: 'line',
          data: []
        }
      ]
    }
    @Watch('timeRange')
    getTimeRange(newVal: [number, number]) {
      this.searchParams.fromTime = newVal[0] || ''
      this.searchParams.toTime = newVal[1] || ''
    }
    created() {
      this.getInfo()
    }
    // 重置
    private reset() {
      this.searchParams.fromTime = ''
      this.searchParams.toTime = ''
      this.timeRange = []
      this.getInfo()
    }

    // 搜索
    private search() {
      this.getInfo()
    }
    private async getInfo() {
      // this.loading = true
      const { data } = await punchCardStatistics({ ...this.searchParams, studentId: this.id })
      console.log(data)
      this.$fn.setVal(this.info, data)
      this.weekChartOptions1.xAxis.data = []
      this.weekChartOptions2.xAxis.data = []
      this.weekChartOptions1.series[0].data = []
      this.weekChartOptions2.series[0].data = []
      this.monthChartOptions1.xAxis.data = []
      this.monthChartOptions2.xAxis.data = []
      this.monthChartOptions1.series[0].data = []
      this.monthChartOptions2.series[0].data = []
      data.weeks.map((item:any) => {
        let xStr = dayjs(item.startTime).format('MM/DD') + '-' + dayjs(item.endTime).format('MM/DD')
        this.weekChartOptions1.xAxis.data.push(xStr)
        this.weekChartOptions2.xAxis.data.push(xStr)
        this.weekChartOptions1.series[0].data.push(item.time)
        this.weekChartOptions2.series[0].data.push(item.duration)
      })
      data.months.map((item:any) => {
        let xStr = dayjs(item.startTime).format('M月')
        this.monthChartOptions1.xAxis.data.push(xStr)
        this.monthChartOptions2.xAxis.data.push(xStr)
        this.monthChartOptions1.series[0].data.push(item.time)
        this.monthChartOptions2.series[0].data.push(item.duration)
      })

      if (!this.timeRange.length) {
        this.timeRange = [data.fromTime, data.toTime]
      }

      (this.$refs.weekChart1 as any).setOption(this.weekChartOptions1)
      ;(this.$refs.weekChart2 as any).setOption(this.weekChartOptions2)
      ;(this.$refs.monthChart1 as any).setOption(this.monthChartOptions1)
      ;(this.$refs.monthChart2 as any).setOption(this.monthChartOptions2)

      // this.loading = false
    }
    private back() {
      this.$router.go(-1)
    }
}
